<script>
	// Stores 
	import { textSite } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";
	import Vitrine		from '../components/Vitrine.svelte'

   	// Code	
	let titlePage = 'Pague com PicPay';

	let vitrines = [
		{
			image: 'vitrinePicPay2.png', 
			imageMobile: 'vitrinePicPay2M.png', 
			title: 'PicPay',
			href: '#'
		},
	];
</script>

<Vitrine vitrines={vitrines} showDots={false} vitrineHeight="460px"/>

<PageHeader title={titlePage} buttons="">
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<p class="mt-20">Pague e parcele seu aluguel e condomínio em até 12 vezes no aplicativo PicPay!</p>
		</div>
	</div>
</PageHeader>

<div class="container clearfix">
	<p>Com a crise mundial causada pelo Covid-19, muitas pessoas estão encontrando dificuldades em manter suas contas em dia. Pensando nisso a Freire Imóveis gostaria de indicar uma solução que pode ajudar a dar um tão esperado fôlego para encarar este momento adverso.</p>
	<p>O aplicativo PicPay permite que você pague seus boletos utilizando o cartão de crédito, dando ainda a opção de parcelar em até 12 vezes. Para tanto, o aplicativo cobra uma taxa de 2,99% sobre o valor do pagamento e mais 3,49% sobre cada parcela. Lembrando que é necessário ter limite compatível no cartão de crédito.</p>
	<p>Para baixar o aplicativo busque na Play Store (Android) ou na Apple Store (iOS) pelo aplicativo PicPay. Depois você deverá preencher um cadastro e adicionar um cartão de crédito válido. Por fim, deverá clicar em ''Pagar Conta'' e escolher se deseja digitar ou usar o leitor de código de barras e seguir as instruções em tela.</p>
	
	<div class="background-gray round-all pa-40 mt-20 mb-20">
		<p class="color-primary"><b>Confira um exemplo de parcelamento:</b></p>
		<p>
			Valor do Boleto de Aluguel: R$ 1.390,77 <br>
			Pagamento 12 x via PicPay: 12 x 148,14 = R$ 1.777,68
		</p>
		<p><i>Obs: Você pode optar por pagar à vista ou em menos parcelas também.</i></p>
	</div>
	<p>Eventualmente o PicPay oferece CashBack para os seus pagamentos, ou seja, retorna um percentual do valor pago para a sua conta no aplicativo e este valor poderá ser usado para pagar outras contas.</p>
	<p>Apesar de ser uma possibilidade interessante, recomendamos utilizar este recurso com cautela, pois as parcelas utilizadas vão acumular com os próximos aluguéis e a ideia é ganhar um fôlego e não criar uma bola de neve que possa causar transtornos financeiros no futuro.</p>
	<div class="flex gap-20 pb-30">
		<a href="https://wa.me/5551999795405" class="flex flex-center gap-10 text-bold "><i class="fab fa-whatsapp color-whatsapp fa-2x"></i> (51) 99979-5405</a>
	</div>
</div>